import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateGroup from "./UpdateGroup";
import DeleteGroup from "./DeleteGroup";

const server_backend = config.API_URL;

const Groups = ({ username }) => {

    const [GroupList, setGroupList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [onGroupID, setOnGroupID] = useState(0);
    const [filtersEnabled, setFiltersEnabled] = useState(false);


    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");

    const [statusOrder, setStatusOrder] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;


    useEffect(() => {
        const getGroups = async () => {
            try {
                const response = await axios.get(`${server_backend}/groups/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setGroupList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getGroups();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModal = () => {
        setIsUpdating(false);
    }

    const getGroups = async () => {
        try {
            const response = await axios.get(`${server_backend}/groups/list`, headers);
            if (response.data.RES_CODE === "00") {
                setGroupList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
    };

    const handleFilterStatusChange = (e) => {
        const value = e.target.value;
        setFilterStatus(value);
        FilterGroup(value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const FilterGroup = async (status) => {
        try {
            const response = await axios.get(`${server_backend}/groups/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${status}`, headers);
            setGroupList(response.data.RES_RESULT);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterGroup(filterStatus);
        }
    }, [filterBy, filterStatus, filterValue]);

    const handleColumnClick = (filterValue) => {
        setFilterBy(filterValue);
        handleFilterByChange({ target: { value: filterValue } });
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = GroupList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(GroupList.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };



    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>


            {isUpdating ? (
                <div className="container-fluid">

                    <UpdateGroup username={username} onGroupID={onGroupID} onClose={CloseModal} getGroups={getGroups} />
                </div>
            ) : (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Groups List</h4>

                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Groups</a></li>
                                        <li className="breadcrumb-item active">Groups List</li>
                                    </ol>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card" id="tasksList">
                                <div className="card-header border-0">
                                    <div className="d-flex align-items-center">
                                        <h5 className="card-title mb-0 flex-grow-1">All Groups</h5>

                                        <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                            <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                            </button>
                                        </div>

                                        <div className="flex-shrink-0">
                                            <Link className="btn btn-danger add-btn" to="/create-Group">
                                                <i className="ri-add-line align-bottom me-1"></i> Create Groups
                                            </Link>
                                        </div>

                                    </div>
                                </div>
                                {filtersEnabled && (
                                    <div className="card-body border border-dashed border-end-0 border-start-0">
                                        <form>
                                            <div className="row g-3">
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            data-choices
                                                            data-choices-search-false
                                                            name="choices-single-default"
                                                            id="idFilterBy"
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterByChange}
                                                        >
                                                            <option value="">Filter by</option>
                                                            <option value="name">Name</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="input-light">
                                                        <select
                                                            className="form-control custom-select-style"
                                                            data-choices
                                                            data-choices-search-false
                                                            name="choices-single-default"
                                                            id="idFilterStatus"
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterStatusChange}
                                                        >
                                                            <option value={0}>Filter status</option>
                                                            <option value={1}>ACTIVATED</option>
                                                            <option value={2}>DISABLED</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search bg-light border-light"
                                                            placeholder="Search for tasks or something..."
                                                            disabled={!filtersEnabled}
                                                            onChange={handleFilterValueChange}
                                                        />
                                                        <i className="ri-search-line search-icon"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )}

                                <div className="card-body">
                                    <div
  className="table-responsive table-card mb-4"
  style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
>
  <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th scope="col">
                                                        <div className="form-check">
                                                            ID
                                                        </div>
                                                    </th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("name")}>Name</th>
                                                    <th className="th-hover">Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {currentItems.map((Groups_L) => (
                                                    <tr key={Groups_L.grp_ID}>
                                                        <th scope="row">
                                                            <div className="form-check">
                                                                {Groups_L.grp_ID}
                                                            </div>
                                                        </th>
                                                        <td className="client_name">{Groups_L.name}</td>
                                                        <td className="status">
                                                            <span className={`${Groups_L.status_name === 'ACTIVATED' ? "badge badge-soft-success" : "badge badge-soft-danger"} text-uppercase`}>
                                                                {Groups_L.status_name}
                                                            </span>

                                                        </td>
                                                        <td className="due_date"><ul className="list-inline hstack gap-2 mb-0">
                                                            <li className="list-inline-item edit">
                                                                <a
                                                                    type="button"
                                                                    onClick={() => {
                                                                        ShowModalUpdate();
                                                                        setOnGroupID(Groups_L.grp_ID);
                                                                    }}
                                                                    className="text-primary d-inline-block edit-item-btn"
                                                                >
                                                                    <i className="ri-pencil-fill fs-16"></i>
                                                                </a>
                                                            </li>

                                                            <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="" data-bs-original-title="Remove">
                                                                <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                    DeleteGroup(Groups_L.grp_ID, username, getGroups);
                                                                }}>
                                                                    <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                </Link>
                                                            </li>
                                                        </ul></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                      
                                    </div>
                                    <div className="row justify-content-between align-items-center">
                                            <div className="col-auto me-3">
                                                <p className="text-muted mb-sm-0">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, GroupList.length)} of {GroupList.length} entries</p>
                                            </div>
                                            <div className="col-auto">
                                                <ul className="pagination pagination-separated pagination-sm justify-content-end mb-sm-0">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage - 1)} className="page-link">←</a>
                                                    </li>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                            <a href="#" onClick={() => handlePageChange(index + 1)} className="page-link">{index + 1}</a>
                                                        </li>
                                                    ))}
                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <a href="#" onClick={() => handlePageChange(currentPage + 1)} className="page-link">→</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}

export default Groups;
